export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/wooUsers/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/wooUsers',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/wooUsers',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/wooUsers/${id}`,
      data: payload,
    });
  },
});
